import React, { Dispatch, SetStateAction } from "react";
import { ColumnsType } from "antd/es/table";
import { CustomBtn } from "../../series/StyledComponent";
import { EditOutlined } from "@ant-design/icons";
import { DeletePopConfirm } from "../../custom-components";
import { authAxios } from "../../utils/session_utils";
import { makeKeyInLowerCaseHelper } from "../../utils";
import { message } from "antd";

export const stationsListColumns = (
	editHelper: (record: any) => void,
	deleteStationList: (record: any) => void
): ColumnsType<any> => [
	{
		title: "S.No",
		key: "serial_no",
		width: "80px",
		render: (_value, _record, index) => index + 1,
	},
	{
		title: "Call Letters",
		dataIndex: "call_letters",
		key: "call_letters",
		width: "100px",
	},
	{
		title: "State",
		dataIndex: "state",
		key: "state",
		width: "250px",
	},
	{
		title: "City",
		dataIndex: "city",
		key: "city",
		width: "250px",
	},
	{
		title: "Channels",
		dataIndex: "channel",
		key: "channel",
		width: "150px",
	},
	{
		title: "Actions",
		dataIndex: "action",
		key: "action",
		width: "80px",
		render: (value, record: any) => {
			return (
				<>
					<CustomBtn
						title="Edit"
						icon={<EditOutlined />}
						type={"link"}
						onClick={e => {
							e.stopPropagation();
							editHelper(record);
						}}
					/>
					<DeletePopConfirm
						title="Delete Station List?"
						deleteHandler={() => deleteStationList(record.id)}
					>
						Are you sure you want to delete this Record?
					</DeletePopConfirm>
				</>
			);
		},
	},
];

export const getStationsList = async (
	setStationsListData: Dispatch<SetStateAction<any[]>>,
	setIsLoading: Dispatch<SetStateAction<boolean>> | null,
	searchQuery?: string
) => {
	try {
		setIsLoading && setIsLoading(true);

		const config = {
			method: "GET",
			url: `${process.env.REACT_APP_BACK_END_API}/snowflake/stations-list?searchQuery=${
				searchQuery ? encodeURIComponent(searchQuery) : ""
			}`,
			headers: {
				"Content-Type": "application/json",
			},
		};

		const response = await authAxios(config);
		const convertedObject = await makeKeyInLowerCaseHelper(response.data.rows);
		setStationsListData(convertedObject);
		setIsLoading && setIsLoading(false);
	} catch (error) {
		console.error("error in fetching Video lists", error);
		setIsLoading && setIsLoading(false);
	}
};

export const saveUpdateStationListHandler = async (data: any, listEditId?: string) => {
	try {
		const config = {
			method: !listEditId ? "POST" : "PUT",
			url: `${process.env.REACT_APP_BACK_END_API}/snowflake/stations-list`,
			data: JSON.stringify(data),
			headers: { "Content-Type": "application/json" },
		};
		const response = await authAxios(config);
		message.success(response.data.message);
	} catch (error) {
		console.error("error in saveUpdateVideoListHandler", error);
		throw new Error("error in video list new data handler");
	}
};
